import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { combineLatest, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { AuthService } from '../oauth0/oauth0.service';
import { BaseFirebaseService } from './base-firebase.service';
import { Group } from '@remodzy/types';

@Injectable({
  providedIn: 'root'
})
export class GroupService extends BaseFirebaseService<Group> {
  constructor(
    auth: AuthService,
    db: AngularFirestore
  ) {
    super(auth, db, environment.firebase.collections.groups);
  }

  getSchedulGroups(start$: any, end$: any, isTimeSheet$: any, team$: any, showGroups$: any) {
    return combineLatest([start$, end$, isTimeSheet$, team$, showGroups$]).pipe(
      switchMap(([start, end, isTimeSheet, team, showGroups]) =>
        start != null && end != null && !isTimeSheet && showGroups ?
          this.db
            .collection(this.collectionName, ref => {
              let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
              query = query.where('tenantId', '==', this.auth.profile?.tenantId);
              if (start) {
                query = query.where('startDate', '>=', start);
              }
              if (end) {
                query = query.where('startDate', '<=', end);
              }
              query = query.where('teamId', '==', team === '' ? null : team);
              return query;
            })
            .stateChanges()
            .pipe(
              map((changes) => {
                return changes.map((doc) => this.mapStateFunction(doc));
              })
            )
          :
          of([])
      )
    );
  }
}
